import React from 'react';
import Container from '@material-ui/core/Container';
import PrivateLayout from '../../../layouts/private';
import UpdateRmaConfigsComponent from './update-rma-configs-component';

class RMAConfigsScreen extends React.Component {

    render() {
        return (
            <PrivateLayout screenTitle="Your RMA Configurations">
                <div className={'lz-form-page lz-form-page-full'}>
                    <Container>

                        <UpdateRmaConfigsComponent />

                    </Container>
                </div>
            </PrivateLayout>
        );
    }

}

export default RMAConfigsScreen;
